import { LanguageService } from '$core/services/language.service';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LangSelectorComponent {
  public readonly faChevronDown = faChevronDown;

  constructor(public languageService: LanguageService) {}

  public onLangSelected(e: Event) {
    const target = e.target as HTMLSelectElement;
    this.languageService.change(target.value);
  }
}
